import React from 'react';
import styles from './styles.module.scss';
import { StyledButton } from "./StyledButton";
import { SharedOptionProps } from "./StyledDropdown";
import { PhonePageType } from "../../types";
import { AlertIcon } from '../Icon/AlertIcon';

export interface ITab extends SharedOptionProps {
    value: PhonePageType;
    notification_count?: number;
    queueWaiting?: boolean;
    queueAllLoggedIn?: boolean;
}

interface Props {
    options: ITab[];
    selected: string;
    onChange: (val: string) => void;
}

const StyledPageTabs: React.FC<Props> = ({ options, selected, onChange }) => (
    <div className={styles.styled_page_tabs}>
        {options.map((opt) => {
            let icon: any = null;
            if (opt.queueWaiting) {
                icon = (
                    <AlertIcon size={16} />
                );
            } else if (opt.queueAllLoggedIn === false) {
                icon = (
                    <span
                        style={{
                            display: 'inline-block',
                            width: 10,
                            height: 10,
                            marginLeft: 8,
                            borderRadius: '50%',
                            backgroundColor: 'grey',
                        }}
                    />
                );
            } else if (opt.queueAllLoggedIn === true) {
                icon = (
                    <span
                        style={{
                            display: 'inline-block',
                            width: 10,
                            height: 10,
                            marginLeft: 8,
                            borderRadius: '50%',
                            backgroundColor: 'green',
                        }}
                    />
                );
            }

            return (
                <StyledButton
                    key={opt.value}
                    buttonStyle="text"
                    disabled={!!opt.disabled}
                    onClick={() => onChange(opt.value)}
                    dataTags={{
                        "data-selected": selected === opt.value || null,
                    }}
                >
                    <h2>
                        {opt.label}
                        {/* Show notification count if present */}
                        {opt.notification_count ? (
                            <i>
                                {opt.notification_count > 99
                                    ? "+99"
                                    : opt.notification_count}
                            </i>
                        ) : null}
                        {icon}
                    </h2>
                </StyledButton>
            );
        })}
    </div>
);

export default StyledPageTabs;
